// extracted by mini-css-extract-plugin
export var active = "_gc-2";
export var recordingDot = "_gc-1";
export var recordingIndicator = "_gc-0";